import { CiSearch } from "react-icons/ci";
import { filterBySearch } from "../../../utils/filterUtils";
import { useProductsContext } from "../../../front/contexts";
import { useEffect, useRef, useState } from "react";
import CartItemCard from "../cart/CartItemCard";
import { useLocation, useNavigate } from "react-router-dom";
//import spinningLoaders from "../../../assets/loaderBlack.svg";
import services from '../../../services/index'
import commonObj from '../../../utils/Common';

let spinningLoaders = ''
const Search = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { allProducts, applyFilters } = useProductsContext();
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showList, setShowList] = useState(true);
  const [searching, setSearching] = useState(false);
  const [imgurl, setimgurl] = useState();

  // Tracks the most recently fired request so a slow, stale response
  // can never overwrite the results of a newer one (race condition guard).
  const latestRequestId = useRef(0);

  useEffect(() => {
    if (location?.pathname !== "/products") {
      setSearch("");
    }
  }, [location]);

  // Single source of truth for the live dropdown: debounce the typed
  // value, then fetch. Nothing fetches outside of this effect anymore.
  useEffect(() => {
    if (search.trim().length <= 2) {
      setFilteredData([]);
      setSearching(false);
      if (location?.pathname === "/products" && !search) {
        applyFilters("searchText", search);
      }
      return;
    }

    setSearching(true);
    const id = setTimeout(() => {
      getProductList(search);
    }, 500);

    return () => {
      clearTimeout(id);
    };
  }, [search]);

  const changeHandler = (e) => {
    setSearch(e.target.value);
    if (!showList) setShowList(true);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    applyFilters("searchText", search);
    setShowList(false);
    navigate("/products");
  };

  const getProductList = async (srch) => {
    const requestId = ++latestRequestId.current;
    try {
      const productsRes = await services.productService.getProductList({ filter: { s: srch } });
      // Ignore this response if a newer request has since been fired.
      if (requestId !== latestRequestId.current) return;

      if (productsRes.status === 1) {
        setimgurl(productsRes.data?.url);
        setFilteredData(filterBySearch(srch, productsRes.data?.list?.rows));
      }
    } finally {
      if (requestId === latestRequestId.current) {
        setSearching(false);
      }
    }
  };

  return (
    <>
      <form
        onSubmit={submitHandler}
        className={`flex items-center py-2 px-3 header-search ${
          search && showList ? "rounded-t-md" : "rounded-full"
        } text-sm transition`}
      >
        <input
          className="w-full  bg-transparent focus:outline-none"
          type="search"
          name="search"
          aria-label={commonObj.getLabel('Search_Your_Product')}
          value={search}
          placeholder={commonObj.getLabel('Search_Your_Product')}
          onChange={changeHandler}
          style={{ boxShadow: "none" }}
        />
        <button type="submit" aria-label="Search" className="flex items-center">
          <CiSearch />
        </button>
      </form>
      {search && showList && (
        <ul className="absolute bg-amber-50 w-full max-h-72 overflow-auto rounded-b-md z-10">
          {searching ? (
            <li className="h-10 flex items-center justify-center">
              <img src={spinningLoaders} alt="Searching..." />
            </li>
          ) : filteredData.length ? (
            filteredData.map((product) => (
              <li key={product.id} className="">
                <CartItemCard
                  product={product}
                  isSearch={true}
                  setSearch={setSearch}
                  imgurl={imgurl}
                />
              </li>
            ))
          ) : (
            <li className="h-10 flex items-center justify-center">
              {commonObj.getLabel('No_Item_to_show')}
            </li>
          )}
        </ul>
      )}
    </>
  );
};

export default Search;
